const DEFAULT_GTFS_TRIP_CHANGES_CACHE_TTL = 600000; // 5 minutes in milliseconds
const DEFAULT_LAST_SERVICE_HOUR = 5;

const getIntegerConfig = (value, defaultValue) => {
  const parsedValue = parseInt(value, 10)
  return !!value && !isNaN(parsedValue)
    ? parsedValue
    : defaultValue
}

export const config = {
  baseURL: process.env.REACT_APP_AT_API_URL ?? 'https://api.at.govt.nz/',
  gtfsChangesCacheTTL: getIntegerConfig(
    process.env.REACT_APP_GTFS_CHANGES_CACHE_TTL,
    DEFAULT_GTFS_TRIP_CHANGES_CACHE_TTL
  ),
  lastServiceHour: getIntegerConfig(
    process.env.REACT_APP_LAST_SERVICE_HOUR,
    DEFAULT_LAST_SERVICE_HOUR
  ),
};